import { connect } from 'react-redux'
import { actions } from '../../../../imports'
import ProgressManager from './component'

function mapDispatchToProps(dispatch) {
    return {
        saveProgress: (serverName, progress) => {
            dispatch(actions.saveProgress(serverName, progress))
        },
        setProgressMessage: (message) => {
            dispatch(actions.setProgressMessage(message))
        },
    }
}

export default connect(null, mapDispatchToProps)(ProgressManager)



// WEBPACK FOOTER //
// ./src/features/Backend/components/Backend/components/ProgressManager/index.js